import { isValidElement } from 'react'

export const reactNodeToString = (reactNode): string => {
  if (typeof reactNode === 'string') {
    return reactNode
  }
  if (typeof reactNode === 'number') {
    return reactNode.toString()
  }
  if (Array.isArray(reactNode)) {
    return reactNode.map(reactNodeToString).join('')
  }
  if (isValidElement(reactNode as any)) {
    return reactNodeToString(reactNode.props.children)
  }
  return ''
}